import { useMemo } from 'react';

export function useColoredVerificationUri(verificationUri: string): string {
  return useMemo(() => {
    const coloredUri = new URL(verificationUri);
    coloredUri.searchParams.set('color', 'developer');
    coloredUri.searchParams.set('studio', 'true');
    return coloredUri.toString();
  }, [verificationUri]);
}
